import { Box, Typography } from "@mui/material";
import cluppcitoSad from "../../../Assets/Clupp_Triste.png";

const Final = ({ state, setState, field }) => {
  return (
    <>
      {state?.isPartialCancellation ? (
        <Box textAlign="center" width="100%" padding={0}>
          <Typography variant="h6" gutterBottom>
            {`${
              state?.clientName
            }, hemos recibido exitosamente tu solicitud de cancelación para el ${
              state?.isADevice ? "dispositivo" : "vehículo"
            } ${state.productName}.`}
          </Typography>
          <Typography variant="body1">
            Una vez que se complete el proceso, recibirás por correo una carta
            de confirmación, que asegura que no se te harán más cobros ni
            tendrás cobertura. Si no la recibes, por favor contáctanos al{" "}
            <a href={`https://wa.me/5215577460177`}>
              <strong>5577460177</strong>
            </a>{" "}
            y pide hablar con un agente para que podamos ayudarte.{" "}
            <span role="img" aria-label="slightly smiling face">
              🙂
            </span>
          </Typography>
        </Box>
      ) : (
        <Box textAlign="center" width="100%" padding={0}>
          <img
            src={cluppcitoSad}
            alt="Cluppcito Sad"
            style={{ width: 150, height: 190, marginBottom: 3 }}
          />
          <Typography variant="h6" gutterBottom>
            {`Te confirmamos que tu${state.isMoreThanOne ? "s" : ""} cobertura${
              state.isMoreThanOne ? "s" : ""
            } con Clupp ha${state.isMoreThanOne ? "n" : ""} sido cancelada${
              state.isMoreThanOne ? "s" : ""
            },
            vía correo te habrá llegado tu carta cancelación.`}
          </Typography>
          <Typography variant="body1">
            Pensamos que nunca llegaría este día pero lamentamos mucho que
            decidas irte.{" "}
            <span role="img" aria-label="sleepy face">
              😪
            </span>
          </Typography>
          <Typography variant="body1">
            Te agradecemos por confiar en Clupp y esperamos tenerte de vuelta
            pronto.
          </Typography>
          <Typography variant="body1" gutterBottom>
            {`Si cambias de opinión o necesitas cualquier cosa, aquí estaremos para ayudarte a proteger tu${
              state.isMoreThanOne ? "s" : ""
            } vehículo${state.isMoreThanOne ? "s" : ""} y/o gadgets.`}
          </Typography>
          <Typography
            variant="body1"
            sx={{ fontWeight: 600, marginTop: "15px" }}
          >
            ¡Hasta pronto!{" "}
            <span role="img" aria-label="waving hand">
              👋🏼
            </span>
          </Typography>
        </Box>
      )}
    </>
  );
};

export default Final;
